import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, Divider, Grid, GridRow, Header, Icon, Input, Label, Modal, Segment, SegmentGroup, Table } from 'semantic-ui-react';
import * as UserAdmin from '..';
import { ApplicationState, routes, strings } from '../..';
import { UbicazioneCustom } from '../models';
import { mediaStyles, MediaContextProvider, Media } from '../../core'; 
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from '../../../application-insight/telemetryService';

const connector = connect(
    (state: ApplicationState) => ({
        ubicazioniCustom: state.userAdmin.ubicazioni,
    }),
    UserAdmin.actions
)
type PropsFromRedux = ConnectedProps<typeof connector>

type UbicazioniCustomProps = PropsFromRedux
type UbicazioniCustomState = {
    search: string,
    modalOpen: boolean,
    confirmOpen: boolean,
    selezionate: ReadonlyArray<UbicazioneCustom>
}

class UbicazioniCustom extends React.Component<UbicazioniCustomProps, UbicazioniCustomState> {

    constructor(props: UbicazioniCustomProps) {
        super(props);

        this.state = {
            search: '',
            modalOpen: false,
            confirmOpen: false,
            selezionate: [],
        };
    }

    componentDidMount() {
        this.props.loadUbicazioni();
    }
    
    render() {
        const { selezionate } = this.state;
        return (            
            <>
                <style>{mediaStyles}</style>
                <MediaContextProvider>
                    <Media greaterThanOrEqual="tablet">
                        <Grid centered>
                            {this.renderIntestazione()}
                            <Grid.Row />
                            {selezionate.map(this.renderUbicazione)}
                            <Grid.Row />
                            {this.renderSalvataggio(false)}
                        </Grid>
                    </Media>
                    <Media at="mobile">
                        <Grid centered>
                            {this.renderIntestazione()}
                            {this.renderSalvataggio(true)}
                            {selezionate.map(this.renderUbicazioneMobile)}
                        </Grid>
                    </Media>
                </MediaContextProvider>
                <Modal size='tiny' closeOnEscape={true} open={this.state.modalOpen} onClose={this.closeModal}>
                    <Modal.Header>Attenzione</Modal.Header>
                    <Modal.Content>Inserire almeno 3 caratteri nella ricerca</Modal.Content>
                    <Modal.Actions>
                        <Button primary onClick={this.closeModal}>OK</Button>
                    </Modal.Actions>
                </Modal>
                <Modal size='tiny' open={this.state.confirmOpen}>
                    <Modal.Header>Attenzione</Modal.Header>
                    <Modal.Content>Le modifiche non salvate verranno annullate, proseguire?</Modal.Content>
                    <Modal.Actions>
                        <Button color='red' onClick={this.closeConfirm}>
                            <Icon name='remove' /> Annulla
                        </Button>
                        <Button color='green' onClick={this.executeSearch}>
                            <Icon name='checkmark' /> Continua
                        </Button>
                    </Modal.Actions>
                </Modal>
            </>
        );
    }

    renderIntestazione = () => (
        <>
            <Grid.Row key='intestazione'>
                <Header as='h2' textAlign='center'>
                    <Icon name='map marker alternate' />
                    <Header.Content>
                        {strings.userAdmin.ubicazioni.titolo}
                        <Header.Subheader>{strings.userAdmin.ubicazioni.sottotitolo}</Header.Subheader>
                    </Header.Content>
                </Header>
            </Grid.Row>
            <Grid.Row key='ricerca'>
                <Grid.Column />
                <Grid.Column mobile='15' tablet='10' computer='7'>
                    <Input
                        fluid
                        icon={<Icon onClick={this.onSearch} name="search" inverted circular link />}
                        placeholder="Ricerca matricola..."
                        value={this.state.search}
                        onChange={this.onSearchChange}
                        onKeyPress={this.onKeyPress}/>
                </Grid.Column>
                <Grid.Column />
            </Grid.Row>
        </>
    )

    renderSalvataggio = (mobile: boolean) => (
        <Grid.Row key='salvataggio'>
            <Grid.Column width='7' textAlign={mobile ? 'left' : 'right'}>
                <Button primary icon labelPosition='left' as={Link} to={routes.core.main} style={{ width:130 }}>
                    <Icon name='arrow left' />
                    {strings.core.azioni.indietro}
                </Button>
            </Grid.Column>
            <Grid.Column width='1' />
            <Grid.Column width='7' textAlign={mobile ? 'right' : 'left'}>
                <Button icon labelPosition='left' color='green' onClick={this.salvaUbicazioni} style={{ width:130 }}>
                    <Icon name='save' />
                    {strings.core.azioni.salva}
                </Button>
            </Grid.Column>
        </Grid.Row>
    )

    renderUbicazione = (ubicazione: UbicazioneCustom) => (
        <React.Fragment key={ubicazione.idSpecifica}>
            <Grid.Row key={ubicazione.idSpecifica} style={{ padding: 3 }}>
                <Grid.Column tablet='7' computer='5' widescreen='4'>
                    <div><b>NUMERO MACCHINA</b></div>
                    <Input fluid value={ubicazione.numeroMacchina} transparent 
                        style={{ padding: '.67857143em 1em' }} />
                    <Divider hidden style={{ padding: 1, margin: 2 }} />

                    <div><b>MATRICOLA</b></div>
                    <Input fluid value={ubicazione.matricola + '  -  ' + ubicazione.attrezzatura}
                        transparent style={{ padding: '.67857143em 1em' }} />
                    <Divider hidden style={{ padding: 1, margin: 2 }} />

                    <div><b>DESTINATARIO</b></div>
                    <Input fluid value={ubicazione.destinatario}
                        transparent style={{ padding: '.67857143em 1em' }} />
                </Grid.Column>
                
                <Grid.Column tablet='7' computer='6' widescreen='5'>

                    <div><b>EDIFICIO: </b>{(ubicazione.edificio === '' ? '(non impostato)' : ubicazione.edificio)}</div>
                    <Input fluid placeholder='Imposta il nuovo edificio' value={ubicazione.edificioNuovo} iconPosition='left'
                           onChange={(event) => this.modificaEdificio(ubicazione, event.target.value)}>
                        <Icon name='building' />
                        <input />
                        {ubicazione.isModificatoEdificio() ? this.renderLabelModificato() : null}
                    </Input>
                    <Divider hidden style={{ padding: 1, margin: 2 }} />

                    <div><b>PIANO: </b>{ubicazione.piano === '' ? '(non impostato)' : ubicazione.piano}</div>
                    <Input fluid placeholder='Imposta il nuovo piano' value={ubicazione.pianoNuovo} iconPosition='left'
                           onChange={(event) => this.modificaPiano(ubicazione, event.target.value)}>
                        <Icon name='map outline' />
                        <input />
                        {ubicazione.isModificatoPiano() ? this.renderLabelModificato() : null}
                    </Input>
                    <Divider hidden style={{ padding: 1, margin: 2 }} />

                    <div><b>UFFICIO: </b>{ubicazione.ufficio === '' ? '(non impostato)' : ubicazione.ufficio}</div>
                    <Input fluid placeholder='Imposta il nuovo ufficio' value={ubicazione.ufficioNuovo} iconPosition='left'
                           onChange={(event) => this.modificaUfficio(ubicazione, event.target.value)}>
                        <Icon name='thumbtack' />
                        <input />
                        {ubicazione.isModificatoUfficio() ? this.renderLabelModificato() : null}
                    </Input>
                    <Divider hidden style={{ padding: 1, margin: 2 }} />

                    <div><b>REFERENTE: </b>{ubicazione.referente === '' ? '(non impostato)' : ubicazione.referente}</div>
                    <Input fluid placeholder='Imposta il nuovo referente' value={ubicazione.referenteNuovo} iconPosition='left'
                           onChange={(event) => this.modificaReferente(ubicazione, event.target.value)}>
                        <Icon name='user' />
                        <input />
                        {ubicazione.isModificatoReferente() ? this.renderLabelModificato() : null}
                    </Input>

                </Grid.Column>
            </Grid.Row>
            <Grid.Row tablet='15' computer='14' widescreen='13'><hr style={{ width: '75%', color: 'lightgrey' }} /></Grid.Row>
        </React.Fragment>
    )

    renderUbicazioneMobile = (ubicazione: UbicazioneCustom) => (
        <React.Fragment key={ubicazione.idSpecifica}>
            <Grid.Row verticalAlign='middle' style={{ padding: 3 }}>
                <Grid.Column width='2'><b>{ubicazione.numeroMacchina}</b></Grid.Column>
                <Grid.Column width='6'>{ubicazione.matricola}</Grid.Column>
                <Grid.Column width='7'>{ubicazione.attrezzatura}</Grid.Column>        
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width='15'>{ubicazione.destinatario}</Grid.Column>
            </Grid.Row>
            <Grid.Row stretched style={{ padding: 3 }}>
                <Grid.Column width='15' verticalAlign='middle' textAlign='left'>
                    <div><b>EDIFICIO: </b>{(ubicazione.edificio === '' ? '(non impostato)' : ubicazione.edificio)}</div>
                    <Input fluid placeholder='Imposta il nuovo edificio' value={ubicazione.edificioNuovo} iconPosition='left'
                           onChange={(event) => this.modificaEdificio(ubicazione, event.target.value)}>
                        <Icon name='building' />
                        <input />
                        {ubicazione.isModificatoEdificio() ? this.renderLabelModificato() : null}
                    </Input>
                    <Divider hidden style={{ padding: 1, margin: 2 }} />

                    <div><b>PIANO: </b>{ubicazione.piano === '' ? '(non impostato)' : ubicazione.piano}</div>
                    <Input fluid placeholder='Imposta il nuovo piano' value={ubicazione.pianoNuovo} iconPosition='left'
                           onChange={(event) => this.modificaPiano(ubicazione, event.target.value)}>
                        <Icon name='map outline' />
                        <input />
                        {ubicazione.isModificatoPiano() ? this.renderLabelModificato() : null}
                    </Input>
                    <Divider hidden style={{ padding: 1, margin: 2 }} />

                    <div><b>UFFICIO: </b>{ubicazione.ufficio === '' ? '(non impostato)' : ubicazione.ufficio}</div>
                    <Input fluid placeholder='Imposta il nuovo ufficio' value={ubicazione.ufficioNuovo} iconPosition='left'
                           onChange={(event) => this.modificaUfficio(ubicazione, event.target.value)}>
                        <Icon name='thumbtack' />
                        <input />
                        {ubicazione.isModificatoUfficio() ? this.renderLabelModificato() : null}
                    </Input>
                    <Divider hidden style={{ padding: 1, margin: 2 }} />

                    <div><b>REFERENTE: </b>{ubicazione.referente === '' ? '(non impostato)' : ubicazione.referente}</div>
                    <Input fluid placeholder='Imposta il nuovo referente' value={ubicazione.referenteNuovo} iconPosition='left'
                           onChange={(event) => this.modificaReferente(ubicazione, event.target.value)}>
                        <Icon name='user' />
                        <input />
                        {ubicazione.isModificatoReferente() ? this.renderLabelModificato() : null}
                    </Input>
                    <Divider hidden style={{ padding: 1, margin: 2 }} />
                </Grid.Column>
            </Grid.Row>
            <Divider />
        </React.Fragment>
    )

    renderLabelModificato = () => (<Label icon='asterisk' color='teal' corner='right' size='mini' />);

    modificaEdificio = (oggetto: UbicazioneCustom, value: string) => {
        oggetto.setEdificio(value);
        
        this.setState({ ...this.state });
    }
    modificaPiano = (oggetto: UbicazioneCustom, value: string) => {
        oggetto.setPiano(value);
        
        this.setState({ ...this.state });
    }
    modificaUfficio = (oggetto: UbicazioneCustom, value: string) => {
        oggetto.setUfficio(value);
        
        this.setState({ ...this.state });
    }
    modificaReferente = (oggetto: UbicazioneCustom, value: string) => {
        oggetto.setReferente(value);
        
        this.setState({ ...this.state });
    }

    salvaUbicazioni = () => {
        const { selezionate } = this.state;

        this.props.saveUbicazioni(selezionate);
    }

    onSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ search: event.target.value });
    }

    onKeyPress = (event: any) => {
        if (event.key === 'Enter') {
            this.onSearch();
        }
    }

    closeModal = () => this.setState({ modalOpen: false });
    closeConfirm = () => this.setState({ confirmOpen: false });

    onSearch = () => {
        const { search, selezionate } = this.state;
        if (search.length < 3) {
            this.setState({ modalOpen: true });
            return;
        }
        
        if (selezionate.some(u => u.isModificata())) {
            this.setState({ confirmOpen: true });
            return;
        }
        
        this.executeSearch();
    }

    executeSearch = () => {
        this.closeConfirm();

        const { search } = this.state;        
        const { ubicazioniCustom } = this.props;

        const regex = new RegExp(search, "i"); // i: ignore case
        let selezionate: Array<UbicazioneCustom> = [];
        ubicazioniCustom.forEach(u => {
            u.annulla();

            const selezionato = u.matricola.search(regex) != -1     ||
                                u.edificio.search(regex) != -1      ||
                                u.piano.search(regex) != -1         ||
                                u.ufficio.search(regex) != -1       ||
                                u.referente.search(regex) != -1     ||
                                u.attrezzatura.search(regex) != -1  ||
                                u.numeroMacchina === search;
            if (selezionato) {
                selezionate.push(u);
            }
        });

        this.setState({ selezionate });
    }
}

export default connector(withAITracking(ai.reactPlugin, UbicazioniCustom, "UbicazioniCustom"));